package br.com.texeratx.boardgametimeapp.ui.screens.games.detail

import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchListItemUI

data class GameDetailUIModel(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val minPlayers: Int?,
    val maxPlayers: Int?,
    val duration: Int?,
    val categoryId: Long?,
    val category: String?,
    val modeId: Long?,
    val mode: String?,
    val bggUrl: String?,
    val manualUrl: String?,
    val spotifyUrl: String?,
    val matchesPlayed: Int,
    val status: Int,
    val clanId: Long,
    val owners: List<GameDetailOwnerUI>,
    val winners: List<GameDetailWinnerUI>,
    val matches: List<MatchListItemUI>,
    val stats: GameDetailStatsUI,
    val scoreStats: GameDetailScoreStatsUI
)

data class GameDetailOwnerUI(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val nickname: String?,
    val birthday: String?,
    val phone: String?,
    val status: Int,
    val clanId: Long
)

data class GameDetailWinnerUI(
    val id: Long,
    val name: String,
    val imageUrl: String?,
    val nickname: String?,
    val wins: Int
)

data class GameDetailStatsUI(
    val matchesPlayed: Int,
    val matchesPlayedCurrentYear: Int,
    val lastPlayedDate: String? = null,
    val firstPlayedDate: String? = null,
    val averageDurationInMinutes: Int? = null,
    val longestDurationInMinutes: Int? = null,
    val shortestDurationInMinutes: Int? = null
)

data class GameDetailScoreStatsUI(
    val highestScore: Double? = null,
    val highestScorePlayers: List<GameDetailScorePlayerUI> = emptyList(),
    val winnerAverageScore: Double? = null,
    val lowestScore: Double? = null,
    val lowestScorePlayers: List<GameDetailScorePlayerUI> = emptyList()
)

data class GameDetailScorePlayerUI(
    val id: Long,
    val name: String
)
